export function JitteryBars() {
  const heights = [67, 42, 85, 55, 73, 38, 91, 60, 48, 78, 35, 88, 52, 70, 45, 82];
  const durations = [0.42, 0.55, 0.38, 0.61, 0.47, 0.33, 0.58, 0.44, 0.5, 0.36, 0.53, 0.4, 0.57, 0.43, 0.48, 0.39];

  return (
    <div className='flex h-32 w-full items-end gap-1'>
      {heights.map((h, i) => (
        <div key={i} className='flex-1 rounded-t bg-red-500/80' style={{ animation: `jitter ${durations[i]}s ease-in-out infinite alternate`, animationDelay: `${i * 0.05}s`, height: `${h}%` }} />
      ))}
      <style>{`
        @keyframes jitter {
          0% { transform: scaleY(1); opacity: 0.7; }
          50% { transform: scaleY(0.5); opacity: 1; }
          100% { transform: scaleY(0.7); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
}
